import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import { ComicGroup } from '../types';

interface GroupFormModalProps {
  open: boolean;
  // null = adding
  group: ComicGroup | null;
  onClose: () => void;
  onSave: (name: string) => Promise<boolean>;
}

const GroupFormModal = ({ open, group, onClose, onSave }: GroupFormModalProps) => {
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    setName(group?.name ?? '');
    setSaving(false);
  }, [open, group]);

  const handleSave = async () => {
    setSaving(true);
    const saved = await onSave(name.trim());
    setSaving(false);
    if (saved) onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{group ? 'Rename Group' : 'New Group'}</DialogTitle>

      <DialogContent dividers>
        <TextField
          label="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && name.trim()) handleSave();
          }}
          placeholder="e.g. Batman, Vertigo"
          autoFocus
          fullWidth
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSave} disabled={!name.trim() || saving}>
          {group ? 'Save' : 'Add Group'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GroupFormModal;
